import { Modal } from "@visiblethread/react-components";
import LoadingCard from "components/LoadingCard";
import PropTypes from "prop-types";
import React from "react";

import styles from "./LoadingModal.module.scss";

const LoadingModal = ({ message }) => {
  return (
    <Modal show centered backdrop className="fade-in">
      <LoadingCard className={styles.dialog} message={message} />
    </Modal>
  );
};

LoadingModal.propTypes = {
  message: PropTypes.string,
};

export default LoadingModal;
